export default __webpack_public_path__ + "static/media/you-are-bestest.06b4d41b.webp";